export const SELECTION_KEYS = [
  'Enter',
  ' ',
  'ArrowRight',
];
export const UNSELECT_KEYS = [
  'Escape',
  'ArrowLeft',
];
export const MENU_SELECT_EVENT = 'menu-item-select';
export const ITEM_SELECTOR = '[menu-item=""]';
